<template>
    <div
        class="expense-row" 
        @click="$router.push({name: 'engineer.expenses.edit', params: {id: expense.id}})"
    >
        <div class="expense-row-header">
            <h4>{{ expense.expense_date | date }}</h4>
            <span
                class="expense-row-status"
                :class="expense.status.toLowerCase()"
            >{{ expense.status }}</span>
        </div>
        <div class="expense-row-body">
            <p>
                <strong>Amount:</strong> £{{ expense.expense_amount | money }}
            </p>
            <p v-if="expense.vehicle_reg">
                <strong>Vehicle:</strong> {{ expense.vehicle_reg }}
            </p>
            <div>
                <strong>Notes:</strong>
                <div v-html="expense.notes_html" />
            </div>
            <p v-if="expense.reviewer">
                <strong>Reviewed by:</strong> {{ expense.reviewer.name }}
            </p>
            <p v-if="expense.payment_method">
                <strong>Payment method:</strong> {{ expense.payment_method }}
            </p>
            <p v-if="expense.payment_amount">
                <strong>Payment amount:</strong> £{{ expense.payment_amount | money }}
            </p>
            <p>
                <router-link
                    :to="{name: 'engineer.expenses.edit', params: {id: expense.id}}"
                    class="btn btn-info"
                >
                    View
                </router-link>
            </p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        expense: {
            required: true,
            type: Object,
        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/engineer/ExpenseRow.vue